define((require) => {
    "use strict";

    var Backbone      = require("backbone"),
        ImprovedModel = require("shared/zbone/ImprovedModel"),
        User          = require("editor/ui/user/User"),
        TextUtil      = require("shared/util/TextUtil"),
        Syncer        = require("shared/services/sync/Syncer"),
        RestApi       = require("shared/services/RestApi");

    /**
     * Represents a comment in the editor (only).
     *
     * @author Bruce Mackenzie Nielsen
     * @class Comment
     * @constructor
     */
    return ImprovedModel.extend("Comment", {

        url: function() {
            if (this.isNew()) {
                // Reply
                if (this.get("parentId")) {
                    return RestApi.pathToSpecificResource(RestApi.Collections.COMMENTS, this.get("parentId"));
                }
                // New thread. Scene and experience must be added to the object on creation.
                return RestApi.pathToCollectionOnSubResource(
                    RestApi.Collections.EXPERIENCES, this.experience,
                    RestApi.Collections.SCENES, this.sceneID, RestApi.Collections.COMMENTS
                );
            }
            return RestApi.pathToSpecificResource(RestApi.Collections.COMMENTS, this.get("id"));
        },

        defaults: {
            createdBy:   null,
            createdAt:   null,
            content:     "",
            replies:     [],
            unread:      0,
            isUnread:    false
        },

        relations: [{
            type: Backbone.Many,
            key: "replies",
            relatedModel: Backbone.Self
        }],

        computed: {
            user: {
                deps: ["createdBy"],
                resolvePromises: true,
                computeDefault: true,
                value: function(createdBy) {
                    return createdBy && User.findById(createdBy); // users not cached, so no need to fetch entire collection
                }
            },
            isNew: {
                deps: ["createdBy"],
                value: function(createdBy) {
                    return !createdBy;
                }
            },
            // Transient properties used for unread comment handling
            unread: {},
            isUnread: {}
        },

        constructor: function() {
            this.__super();
            Syncer.State.init(this, {permissions: {}}); // no permissions required for comments
        },

        _distinguishedName: function() {
            return TextUtil.firstLine(this.get("content"), true); // true = quote the name
        },

        /**
         * Gets the number of unread comments since the given timestamp.
         * @param {number} since The timestamp in server time to use when determining unread comments.
         * @returns {number} The number of unread comments.
         */
        getUnreadComments: function(since) {
            var replies = this.get("replies").models;

            // Look backwards through the replies for the first reply that is read, if there is a match, all later
            // replies are unread
            var i = replies.length;
            while (i--) {
                if (replies[i].get("createdAt") < since) {
                    return replies.length - i - 1;
                }
                replies[i].set("isUnread", true);
            }

            // Check if the root comment is unread
            if (this.get("createdAt") > since) {
                this.set("isUnread", true);
                return replies.length + 1;
            }

            // No read comments were found in the replies, so all replies are unread
            return replies.length;
        },

        /**
         * Get the position of the comment after scaling by zoom level.
         * @param {number} scaleFactor example 1.5 = 150%
         */
        getScaledPosition: function(scaleFactor) {
            return {
                top: this.get("top") * scaleFactor,
                left: this.get("left") * scaleFactor
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/comments/Comment.js